module.exports = __webpack_public_path__ + "static/media/banner_Informacoes.21896820.jpg";